<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Viewer.email')"
    width="820px"
    :close-on-click-modal="false"
    class="app-main-inner emailInputDialog"
    append-to-body
  >
    <div class="app-main-inner-row" style="flex-direction: column;margin: 0 auto;">
      <div v-show="!isQuotation">
        <el-radio-group v-model="customerType" no="1" @change="changeHandler()">
          <el-radio :label="1">{{ $t('SeaExport.Customer') }}</el-radio>
          <el-radio :label="2">{{ $t('SeaExport.ShippingCmp') }}</el-radio>
          <el-radio :label="3">{{ $t('SeaExport.BookingAgent') }}</el-radio>
          <el-radio :label="4">{{ $t('SeaExport.LocalAgent') }}</el-radio>
          <el-radio :label="5">{{ $t('SeaExport.UpDestAgent') }}</el-radio>
          <el-radio :label="6">{{ $t('SeaExport.NominatedAgent') }}</el-radio>
          <el-radio :label="7">{{ $t('SeaExport.Haulage') }}</el-radio>
          <el-radio :label="8">{{ $t('SeaExport.Warehouse') }}</el-radio>
        </el-radio-group>
      </div>
      <el-form label-width="100px" label-position="right" style="width: fit-content;margin: 0 auto;padding-top:30px;">
        <el-form-item :label="$t('Viewer.company')">
          <cargo-advance-select
            v-show="!isQuotation"
            no="2"
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{[customerTypeName]:true}"
            filterable
            :default-value="customerId||''"
            @parentCallBack="onLoad"
          />
          <el-input v-show="isQuotation" v-model="txtAccount2" no="3" style="width:410px;" />
        </el-form-item>
        <el-form-item :label="$t('Viewer.emailAddress')">
          <!--<el-select v-show="!isQuotation" v-model="emailForm.to" filterable style="width:410px;" @blur="selectBlur">
            <el-option
              v-for="(item,index) in contactList"
              :key="index"
              :label="item.name"
              :value="item.email"
            />
          </el-select>-->
          <cargo-combo-box
            v-show="!isQuotation"
            v-model="emailForm.to"
            no="4"
            style="width:410px;"
            :allow-create="true"
            :clearable="true"
            :options="contactList"
            :label-function="labelFunction"
            value-field="email"
            :forbid-values="['']"
            @clear="onClear"
          />
          <el-input v-show="isQuotation" v-model="txtTo2" no="5" style="width:410px;" />
        </el-form-item>
        <el-form-item>
          <div>
            <el-checkbox v-model="sales" no="6" @change="ccChangeHandler('sales',sales)">{{ $t('SeaExport.Sales') }}</el-checkbox>
            <el-checkbox v-model="op" no="7" @change="ccChangeHandler('sales',op)">{{ $t('SeaExport.Operation') }}</el-checkbox>
            <el-checkbox v-model="csr" no="8" @change="ccChangeHandler('sales',csr)">{{ $t('SeaExport.CustomerService') }}</el-checkbox>
            <el-checkbox v-model="doc" no="9" @change="ccChangeHandler('sales',doc)">{{ $t('SeaExport.Documents') }}</el-checkbox>
            <el-checkbox v-model="defaultCc" no="10">{{ $t('SeaExport.SaveTheDefaultCC') }}</el-checkbox>
          </div>
        </el-form-item>

        <el-form-item :label="$t('Viewer.cc')">
          <el-input v-model="emailForm.cc" no="11" type="textarea" :rows="5" style="width:410px;" />
        </el-form-item>
        <el-form-item :label="$t('Viewer.title')">
          <el-input v-model="emailForm.title" no="12" style="width:410px;" />
        </el-form-item>
        <el-form-item :label="isCopyLink ? $t('Viewer.BlAddress') : $t('Viewer.content')">
          <el-input v-model="emailForm.content" no="13" type="textarea" :rows="5" :placeholder="isCopyLink ? $t('Message.YouTheLinkAddressDirectly') : ''" style="width:410px;" />
        </el-form-item>
        <el-form-item :label="$t('queryJob.SendEmail')" :inline="true">
          <el-checkbox-group v-model="checkList" no="14" @change="statusChange()">
            <div v-for="(item,index) in sendEamilArr" :key="index">
              <el-checkbox :label="item" />
            </div>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button no="15" type="primary" @click="localEmailClickHandler">{{ $t('Viewer.InvokeLocalMailClient') }}</el-button>
      <el-button no="16" :disabled="!okEnable" type="primary" @click="okClickHandler">{{ $t('Viewer.send') }}</el-button>
      <el-button no="17" @click="closeHandler">{{ $t('Viewer.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getSetMailTemplate } from '@/api/sendEmailService'
import { Company } from '@/class/model/mdm/Company'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as userApi from '@/api/user'
import { resolveSpecificField2Value } from '@/utils/basicDataCache'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import cargoComboBox from '@/components/Cargo/Common/cargoComboBox'
import { Job } from '@/class/model/booking/Job'
import { getJobByUuid } from '@/api/booking/job'

export default {
  name: 'EmailInputDialog',
  components: { cargoAdvanceSelect, cargoComboBox },
  props: {
    visible: { type: Boolean, required: true },
    context: {
      type: Object,
      required: true
    },
    jobModel: {
      type: Object,
      required: true
    },
    sendEmailData: {
      type: Object,
      required: true
    },
    sendCallBack: {
      type: Function,
      required: false,
      default: null
    },
    jobUuidList: { type: Array, default: null },
    source: { type: String, default: '' } // 来源
  },
  data() {
    return {
      job: {},
      okEnable: true,
      btnCargoSource: false,
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      customerType: 1, // 默认选中项
      customerTypeName: 'customer',
      contactList: [],
      customerId: 0,
      ccList: [],
      checkList: [],
      sendEamilArr: [this.$t('queryJob.SystemEmail')],
      sales: false,
      op: false,
      csr: false,
      doc: false,
      defaultCc: false,
      emailForm: {
        to: '',
        cc: '',
        title: '',
        content: '',
        ids: '',
        pushLink: '4',
        mailType: '0',
        mailContent: ''
      },
      isQuotation: false,
      txtAccount2: '',
      txtTo2: '',
      isCopyLink: false // 是否复制内容
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initInfo()
        this.getSetMailTemplateFunc()
        this.getEamilStatus()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    const localObj = LocalStorageUtilsNew.getConfiguration(this.source + 'EmailInputDialog')
    if (localObj) {
      this.customerType = localObj.customerType
      this.customerTypeName = localObj.customerTypeName
      this.sales = localObj.sales
      this.op = localObj.op
      this.csr = localObj.csr
      this.doc = localObj.doc
      this.defaultCc = localObj.defaultCc
      this.checkList = localObj.checkList
      if (this.sales && this.job.sales) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
        if (userEmail) {
          this.ccList.push(userEmail)
        }
      }
      if (this.op && this.job.op) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
        if (userEmail) {
          this.ccList.push(userEmail)
        }
      }
      if (this.csr && this.job.csr) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
        if (userEmail) {
          this.ccList.push(userEmail)
        }
      }
      if (this.doc && this.job.dc) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
        if (userEmail) {
          this.ccList.push(userEmail)
        }
      }
      // 刷新CC内容
      this.refreshCcTxt()
    }
    if (this.visible) {
      this.innerVisible = true
      this.getEamilStatus()
      if (!localObj) {
        this.reloadDefaultEmailChange()
      }
      this.initInfo()
      this.getSetMailTemplateFunc()
    }
  },
  methods: {
    // 获取可用邮箱
    async getEamilStatus() {
      const data = {
        branchId: this.$store.getters.currentOfficeId,
        enable: 1
      }
      this.sendEamilArr = [this.$t('queryJob.SystemEmail')]
      this.checkList = [this.$t('queryJob.SystemEmail')]
      const personalInfo = await userApi.getPersonalEmail(data).then(resp => resp.data)
      if (personalInfo) {
        personalInfo.map((item) => {
          switch (item.mailType) {
            case '1':
              this.sendEamilArr.push(this.$t('SeaExport.CompanyMail'))
              break
            case '2':
              this.sendEamilArr.push(this.$t('SeaExport.PersonalMailbox'))
              break
          }
        })
      }
    },
    // 获取邮件内容
    async getSetMailTemplateFunc() {
      let jobUuid = ''
      if (this.jobUuidList) {
        jobUuid = this.jobUuidList.join(',')
      } else {
        jobUuid = this.jobModel._data.jobUuid
      }
      const data = {
        jobUuid: jobUuid,
        pushLink: this.emailForm.pushLink
      }
      const res = await getSetMailTemplate(data)
      if (res.ok) {
        this.emailForm.content = res.data.contentTemplate.replace(/ /g, '&nbsp;')
        this.emailForm.mailContent = res.data.contentTemplate.replace(/ /g, '&nbsp;')
      }
    },
    saveCCEmail() {
      const ccObject = {}
      if (this.defaultCc) {
        // eslint-disable-next-line eqeqeq
        if (this.sales && !this.job.sales !== '') {
          ccObject.sales = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
        }
        if (this.op && !this.job.op !== '') {
          ccObject.op = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
        }
        if (this.csr && !this.job.csr !== '') {
          ccObject.csr = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
        }
        if (this.doc && !this.job.dc !== '') {
          ccObject.doc = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
        }
        if (this.defaultCc) {
          ccObject.defaultCc = this.defaultCc
        }
      }
      window.localStorage.setItem('defaultCC', JSON.stringify(ccObject))
    },
    refreshCcTxt() {
      let ccEmail = ''
      for (let i = 0; i < this.ccList.length; i++) {
        if (ccEmail === '') {
          ccEmail = this.ccList[i]
        } else {
          ccEmail = ccEmail + ',\n' + this.ccList[i]
        }
      }
      this.emailForm.cc = ccEmail
    },
    async reloadDefaultEmailChange() {
      const ccItem = JSON.parse(window.localStorage.getItem('defaultCC'))
      if (ccItem !== null) {
        if (ccItem.hasOwnProperty('sales') && this.job.sales !== '') {
          this.sales = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('op') && this.job.op !== '') {
          this.op = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('csr') && this.job.csr !== '') {
          this.csr = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('doc') && this.job.dc !== '') {
          this.doc = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('defaultCc')) {
          this.defaultCc = true
        }
      }
      // 如果自己有操作，销售，单证，客户权限则默认选中
      if (this.$checkPermission(['role_sales']) && this.job.sales !== '' && !this.sales) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
        if (userEmail !== '') {
          this.sales = true
          this.ccList.push(userEmail)
        }
      }
      if (this.$checkPermission(['role_op']) && this.job.op !== '' && !this.op) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
        if (userEmail !== '') {
          this.op = true
          this.ccList.push(userEmail)
        }
      }
      if (this.$checkPermission(['role_csr']) && this.job.csr !== '' && !this.csr) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
        if (userEmail !== '') {
          this.csr = true
          this.ccList.push(userEmail)
        }
      }
      if (this.$checkPermission(['role_doc']) && this.job.dc !== '' && !this.doc) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
        if (userEmail !== '') {
          this.doc = true
          this.ccList.push(userEmail)
        }
      }
      // 刷新CC内容
      this.refreshCcTxt()
    },
    statusChange() {
      if (this.checkList.length > 1) {
        this.checkList.splice(0, 1)
      }
    },
    async initInfo() {
      if (this.jobModel) {
        Object.assign(this.job, this.jobModel)
        let jobUuid = ''
        if (this.jobUuidList) {
          jobUuid = this.jobUuidList[0]
        } else {
          jobUuid = this.jobModel.uuid || this.jobModel.jobUuid || ''
        }
        const dbJob = await getJobByUuid(jobUuid).then(res => {
          return res.data
        })
        if (dbJob) Object.assign(this.job, dbJob)
      }
      this.selectBookAgent()
      this.initContactList({ cmpIdx: this.customerId })
      this.emailForm.title = this.sendEmailData.emailTitle
      this.emailForm.ids = this.sendEmailData.fileIdList
    },
    selectBlur(e) {
      this.emailForm.to = e.target.value
    },
    // 等同于cargoware 中的 方法 loadContactsResultHandler
    async onLoad(company) {
      this.emailForm.to = ''
      this.contactList = null
      this.getCompany(company)
    },
    selectBookAgent() {
      if (!this.isQuotation && this.job && Object.prototype.hasOwnProperty.call(this.job, 'bookingAgent')) {
        this.customerType = 3
        // 自揽货不显示指定货代理 SC
        this.btnCargoSource = this.job.cargoSource !== CargoSource.SC_CARGO_SOURCE.code
        this.customerId = this.job.bookingAgent
        this.getCompany({ cmpIdx: this.customerId })
      }
    },
    getCompany(company) {
      if (!company || !company.cmpIdx || parseInt(company.cmpIdx) <= 0) {
        this.customerId = 0
        this.emailForm.to = ''
        return
      }
      this.loadContactsResultHandler(company)
    },
    async loadContactsResultHandler(company) {
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      this.buildContactsData(contacts)
    },
    getCarrierCompany(company) {
      this.emailForm.to = ''
      this.contactList = null
      this.loadCarrierContactsResultHandler(company)
    },
    async loadCarrierContactsResultHandler(company) {
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts == null || contacts.length === 0) {
        return
      }
      const newContactList = []
      const vesselLineEmailList = []
      // 获取航线代码
      const vesselLine = this.getVesselLine()
      for (const contact of contacts) {
        const item = this.convertContactToEmail(contact)
        if (vesselLine !== '' && contact.airline === vesselLine) {
          vesselLineEmailList.push(item)
        } else {
          newContactList.push(item)
        }
      }
      if (vesselLineEmailList && vesselLineEmailList.length > 0) {
        this.contactList = vesselLineEmailList
        this.emailForm.to = this.contactList[0].email
      } else if (newContactList && newContactList.length > 0) {
        this.contactList = newContactList
        this.emailForm.to = this.contactList[0].email
      }
    },
    /* 车队信息*/
    async loadTruckingResultHandler() {
      if (!this.job.trucking || this.job.trucking.length <= 0) {
        this.job.trucking = ''
      }
      const truckings = await new Job(this.job).getTrucking()
      if (truckings && truckings.length > 0) {
        this.customerId = truckings[0].carryingCmp
      }
      this.getCompany({ cmpIdx: this.customerId })
    },
    /* 查询内装仓库信息*/
    async loadWarehouseSuccess() {
      if (!this.job.warehouseInfo || this.job.warehouseInfo.length <= 0) {
        this.job.warehouseInfo = ''
      }
      const warehouseInfos = await new Job(this.job).getWarehouseInfo()
      if (warehouseInfos && warehouseInfos.length > 0) {
        this.customerId = warehouseInfos[0].warehouseCmp
      }
      this.getCompany({ cmpIdx: this.customerId })
    },
    /* 初始时赋值收件人(联系人)*/
    async initContactList(company) {
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      this.buildContactsData(contacts)
    },
    getVesselLine() {
      const region = resolveSpecificField2Value(TYPE_NAMES.basic_data_Seaport, 'code', this.job.dischargingPortCode, 'region')
      return region
    },
    buildContactsData(contacts) {
      // 获取job 上的联系人
      const defaultContactObj = this.getDefaultEmail(contacts)
      const newContactList = []
      let defalutContactEmail = ''
      if (contacts && contacts.length > 0) {
        for (const item of contacts) {
          if (!item.email) continue
          const obj = {
            name: `[${item.contactPerson}]${item.email}`,
            contact: item.contactPerson,
            email: item.email
          }
          if (defaultContactObj && defaultContactObj.name === obj.name) {
            defalutContactEmail = item.email
          }
          newContactList.push(obj)
        }
      }
      this.contactList = newContactList

      if (!(this.contactList && this.contactList.length > 0)) {
        return
      }
      this.emailForm.to = this.contactList[0].email
      if (defalutContactEmail !== '') this.emailForm.to = defalutContactEmail
    },
    convertContactToEmail(contact) {
      const obj = {
        name: `[${contact.contactPerson}]${contact.email}`,
        contact: contact.contactPerson,
        email: contact.email
      }
      return obj
    },
    /* 邮件发送*/
    okClickHandler() {
      if (!this.toCheckEmailForm()) {
        return
      }
      this.toLocalCache()
      this.saveCCEmail()
      if (this.sendCallBack) {
        let emailAddress = ''
        if (!this.isQuotation) {
          emailAddress = !this.emailForm.to ? this.txtTo2 : this.emailForm.to
        }
        switch (this.checkList[0]) {
          case this.$t('queryJob.SystemEmail'):
            this.emailForm.mailType = '0'
            break
          case this.$t('queryJob.CompanyEmail'):
            this.emailForm.mailType = '1'
            break
          case this.$t('queryJob.PersonalEmail'):
            this.emailForm.mailType = '2'
            break
        }
        this.okEnable = true
        this.sendCallBack(this.emailForm.title, emailAddress, this.emailForm.cc, this.emailForm.content, this.emailForm.mailType)
        //
      }
      this.clearCompany()
    },
    localEmailClickHandler() {
      if (!this.toCheckEmailForm()) {
        return
      }
      this.toLocalCache()
      const emailAddress = !this.emailForm.to ? this.txtTo2 : this.emailForm.to
      parent.location.href = 'mailto:' + emailAddress + '?subject=' + this.emailForm.title + '&cc=' + this.emailForm.cc + '&body=' + this.emailForm.content
    },
    toCheckEmailForm() {
      if (!this.emailForm || !this.emailForm.to) {
        this.$message.error(this.$t('Message.EmailAddressCannotBeEmpty'))
        return false
      } else {
        return true
      }
    },
    // 做本地缓存
    toLocalCache() {
      if (!this.source) {
        return
      }
      LocalStorageUtilsNew.setConfiguration(this.source + 'EmailInputDialog', {
        customerType: this.customerType,
        customerTypeName: this.customerTypeName,
        sales: this.sales,
        op: this.op,
        csr: this.csr,
        doc: this.doc,
        defaultCc: this.defaultCc,
        checkList: this.checkList
      })
    },
    // 抄送信息改变
    ccChangeHandler(p, check) {
      let cc = this.emailForm.cc
      if (cc !== '') {
        cc = cc.replace(/\n/g, '')
        this.ccList = cc.split(',')
      }
      if (this.job[p] !== '') {
        const email = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job[p], 'email')
        if (check) {
          if (email !== '' && !this.ccList.includes(email)) {
            this.ccList.push(email)
          }
        } else {
          for (var value of this.ccList) {
            if (value === email) {
              const index = this.ccList.indexOf(email)
              this.ccList.splice(index, 1)
              break
            }
          }
        }
      }
      // 刷新CC内容
      this.refreshCcTxt()
    },
    /* 客户类型选择*/
    changeHandler() {
      if (!this.job) return
      switch (this.customerType) {
        case 1:
          this.customerId = this.job.customerId
          this.customerTypeName = 'customer'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 2:
          this.customerId = this.job.carrierId
          this.customerTypeName = 'seaCmp'
          this.getCarrierCompany({ cmpIdx: this.customerId })
          break
        case 3:
          this.customerId = this.job.bookingAgent
          this.customerTypeName = 'bookingAgent'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 4:
          this.customerId = this.job.localAgent
          this.customerTypeName = 'localAgent'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 5:
          this.customerId = this.job.destinationAgent
          this.customerTypeName = 'designationAgent'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 6:
          this.customerId = this.job.designationAgent
          this.customerTypeName = 'designationAgent'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 7:
          this.customerId = 0
          this.customerTypeName = 'truckCmp'
          this.loadTruckingResultHandler()
          break
        case 8:
          this.customerId = 0
          this.customerTypeName = 'warehouse'
          this.loadWarehouseSuccess()
          break
      }
    },
    /* 获取默认联系人*/
    getDefaultEmail(contacts) {
      if (contacts && contacts.length > 0) {
        for (const contact of contacts) {
          if (contact.contactPerson === this.job.customerContact) {
            const item = {
              name: `[${contact.contactPerson}]${contact.email}`,
              contact: contact.contactPerson,
              email: contact.email
            }
            return item
          }
        }
      }
      return null
    },
    async closeHandler() {
      this.innerVisible = false
      await this.clearCompany()
    },
    labelFunction(item) {
      return `${item.name}`
    },
    onClear(val) {
      this.emailForm.to = ''
    },
    clearCompany() {
      this.txtTo2 = ''
      this.customerId = 0
      this.emailForm.to = ''
      this.contactList = []
      this.emailForm.title = ''
      this.emailForm.content = ''
      this.emailForm.cc = ''
      this.emailForm.mailContent = ''
    }
  }
}
</script>

<style lang="scss">
  .emailInputDialog {
    .el-form-item .el-select--mini {
      width: 100%;
    }
  }
</style>
